import { render } from "./MapSidebar.vue?vue&type=template&id=0d0a604d"
import script from "./MapSidebar.vue?vue&type=script&lang=js"
export * from "./MapSidebar.vue?vue&type=script&lang=js"

import "./MapSidebar.vue?vue&type=style&index=0&id=0d0a604d&lang=css"
script.render = render

export default script